import Entity from "../entity";
export default class SupplierOfferItem extends Entity<number> {
    offerTimeSlotId: number=0;
    pricePrefix: string;
    offerDateTypeId: number=0;
    offerPrice: number=0;
    price: number=0;
    services: string;
    holeType: number=0;
    payMethod: number=0;
    amount: number=0
    vipReduction:number=0;
    cashback:number=0;
    reduction:number=0;
    offerText:string;

}
